import React from "react";
import "./Button.css";

interface ButtonProps {
  label: string;
  type?: "button" | "submit";
  onClick?: () => void;
  variant?: "solid" | "outlined";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  label,
  type = "button",
  onClick,
  variant = "solid",
  startIcon,
  endIcon,
  loading = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`button ${variant === "outlined" ? "button--outlined" : ""}`}
      disabled={loading}
    >
      {loading ? (
        <span className="button__loader">
          <span></span>
          <span></span>
          <span></span>
        </span>
      ) : (
        <>
          {startIcon && (
            <span className="button__icon button__icon--start">
              {startIcon}
            </span>
          )}
          <span>{label}</span>
          {endIcon && (
            <span className="button__icon button__icon--end">{endIcon}</span>
          )}
        </>
      )}
    </button>
  );
};

export default Button;
